
    import './styles.scoped.css';
    export default {
  "badge": "awsui_badge_1yjyg_gxi4s_178",
  "badge-color-grey": "awsui_badge-color-grey_1yjyg_gxi4s_224",
  "badge-color-green": "awsui_badge-color-green_1yjyg_gxi4s_229",
  "badge-color-blue": "awsui_badge-color-blue_1yjyg_gxi4s_234",
  "badge-color-red": "awsui_badge-color-red_1yjyg_gxi4s_239",
  "badge-color-severity-critical": "awsui_badge-color-severity-critical_1yjyg_gxi4s_244",
  "badge-color-severity-high": "awsui_badge-color-severity-high_1yjyg_gxi4s_249",
  "badge-color-severity-medium": "awsui_badge-color-severity-medium_1yjyg_gxi4s_254",
  "badge-color-severity-low": "awsui_badge-color-severity-low_1yjyg_gxi4s_259",
  "badge-color-severity-neutral": "awsui_badge-color-severity-neutral_1yjyg_gxi4s_264"
};
  